import { render, staticRenderFns } from "./html.vue?vue&type=template&id=035845dc&scoped=true"
import script from "./html.vue?vue&type=script&lang=ts"
export * from "./html.vue?vue&type=script&lang=ts"
import style0 from "./html.vue?vue&type=style&index=0&id=035845dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035845dc",
  null
  
)

export default component.exports